// @flow
import * as React from 'react';
import classNames from 'classnames';

type Props = {
    className?: string,
};

const ModalActions = ({ className, ...rest }: Props) => (
    <div className={classNames('modal-actions', className)} {...rest} />
);

export default ModalActions;
